import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, languageOptions } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "de";
    const saved = window.localStorage.getItem("omniserve.lang");
    return saved && translations[saved] ? saved : "de";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("omniserve.lang", lang);
      document.documentElement.setAttribute("lang", lang);
    }
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: translations[lang] || translations.de,
      languages: languageOptions,
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
